import {
  type OptionsList,
  SelectComboField,
  type SelectComboFieldProps,
} from "components/Forms/SelectCombo/SelectCombo";
import { periodEnum } from "kubb";

type PeriodSelectComboProps = Omit<SelectComboFieldProps, "options">;

function getOptionsList(): OptionsList {
  return [
    { label: "Daily", value: periodEnum.DAILY },
    { label: "Weekly", value: periodEnum.WEEKLY },
    { label: "7 Day", value: periodEnum.SEVEN_DAY },
    { label: "Monthly", value: periodEnum.MONTHLY },
  ];
}

function PeriodSelectCombo(props: PeriodSelectComboProps) {
  return <SelectComboField {...props} options={getOptionsList()} />;
}

export default PeriodSelectCombo;
